export function deriveDbDateFromName(fileName){
      const s = String(fileName || "");

      // 1) YYYY[-_.]MM[-_.]DD
      let m = s.match(/((?:19|20)\d{2})[-_.](0[1-9]|1[0-2])[-_.](0[1-9]|[12]\d|3[01])/);
      if (m) return `${m[1]}-${m[2]}-${m[3]}`;

      // 2) YYYYMMDD
      m = s.match(/((?:19|20)\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])/);
      if (m) return `${m[1]}-${m[2]}-${m[3]}`;

      // 3) DD[-_.]MM[-_.]YYYY
      m = s.match(/(0[1-9]|[12]\d|3[01])[-_.](0[1-9]|1[0-2])[-_.]((?:19|20)\d{2})/);
      if (m) return `${m[3]}-${m[2]}-${m[1]}`;

      return "Datum unbekannt";
    }
